const state = {
  isVisible: true,
  stewardship: {
    title: '',
    hidden: false,
    items: []
  },
  documents: {
    title: '',
    hidden: false,
    items: []
  },
  events: {
    title: '',
    hidden: false,
    items: []
  },
  workgroups: {
    title: '',
    hidden: false,
    items: []
  },
  holidays: {
    title: '',
    hidden: false,
    items: []
  },
  travels: {
    title: '',
    hidden: false,
    items: []
  },
  remoteWorking: {
    title: '',
    hidden: false,
    items: []
  }
}
const getters = {
  getIsVisible: state => state.isVisible,
  getDocuments: state => state.documents,
  getEvents: state => state.events,
  getWorkgroups: state => state.workgroups,
  getHolidays: state => state.holidays,
  getTravels: state => state.travels,
  getRemoteWorking: state => state.remoteWorking,
  getStewardship: state => state.stewardship
}
const mutations = {
  UPDATE_IS_VISIBLE: (state, boolean) => {
    state.isVisible = boolean
  },
  UPDATE_STEWARDSHIP: (state, object) => {
    state.stewardship = { ...object }
  },
  UPDATE_DOCUMENTS: (state, object) => {
    state.documents = { ...object }
  },
  UPDATE_EVENTS: (state, object) => {
    state.events = { ...object }
  },
  UPDATE_WORKGROUPS: (state, object) => {
    state.workgroups = { ...object }
  },
  UPDATE_HOLIDAYS: (state, object) => {
    state.holidays = { ...object }
  },
  UPDATE_TRAVELS: (state, object) => {
    state.travels = { ...object }
  },
  UPDATE_REMOTE_WORKING: (state, object) => {
    state.remoteWorking = { ...object }
  }
}
const actions = {
  updateIsVisible: (store) => {
    const isVisible = store.getters.getIsVisible
    store.commit('UPDATE_IS_VISIBLE', !isVisible)
  },
  updateStewardship: (store, stewardship) => {
    store.commit('UPDATE_STEWARDSHIP', stewardship)
  },
  updateDocuments: (store, documents) => {
    store.commit('UPDATE_DOCUMENTS', documents)
  },
  updateEvents: (store, events) => {
    store.commit('UPDATE_EVENTS', events)
  },
  updateWorkgroups: (store, workgroups) => {
    store.commit('UPDATE_WORKGROUPS', workgroups)
  },
  updateHolidays: (store, holidays) => {
    store.commit('UPDATE_HOLIDAYS', holidays)
  },
  updateTravels: (store, travels) => {
    store.commit('UPDATE_TRAVELS', travels)
  },
  updateRemoteWorking: (store, remoteWorking) => {
    store.commit('UPDATE_REMOTE_WORKING', remoteWorking)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
